import React from 'react';
import axios from 'axios';
import { Lock } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const LEAD_ADDR_FIELDS = [
  ['client_address', 'Morada (rua)', 'col-span-2'], ['client_door', 'Nº porta', ''], ['client_floor', 'Andar', ''],
  ['client_side', 'Lado', ''], ['client_postal_code', 'Código postal', ''], ['client_locality', 'Localidade', 'col-span-2'],
];

const fmtCp = (v) => { const d = (v || '').replace(/\D/g, '').slice(0, 7); return d.length > 4 ? `${d.slice(0, 4)}-${d.slice(4)}` : d; };

export const lookupPostal = async (cp) => {
  try { const { data } = await axios.get(`${API_URL}/postal-code/${cp}`); return data || null; } catch { return null; }
};

// Campos de morada reutilizáveis (Nova Lead e edição)
export const LeadAddressFields = ({ value, onChange, isLocked = () => false, testPrefix = 'lead-addr' }) => {
  const set = async (k, v) => {
    if (k === 'client_postal_code') {
      const cp = fmtCp(v);
      onChange({ client_postal_code: cp });
      if (cp.length === 8) {
        const d = await lookupPostal(cp);
        if (d?.localidade) {
          onChange({
            client_postal_code: cp,
            ...(!isLocked('client_locality') && !value.client_locality ? { client_locality: d.localidade } : {}),
            ...(d.arteria && !isLocked('client_address') && !value.client_address ? { client_address: d.arteria } : {}),
          });
        }
      }
      return;
    }
    onChange({ [k]: v });
  };
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      {LEAD_ADDR_FIELDS.map(([k, l, span]) => (
        <div key={k} className={span}>
          <Label className="text-xs flex items-center gap-1">{isLocked(k) && <Lock className="w-3 h-3 text-slate-400" />}{l}</Label>
          <Input value={value[k] || ''} disabled={isLocked(k)} onChange={(e) => set(k, e.target.value)}
            placeholder={k === 'client_postal_code' ? '0000-000' : ''} data-testid={`${testPrefix}-${k}`} />
        </div>
      ))}
    </div>
  );
};
